import uuidv4 from '~/utils/auth/uuidv4';
import { getSignalRTabId, setSignalRTabId } from '~/services/localStorage/signalr';

const getOrCreateSignalRTabId = (): string => {
  const existingTabId = getSignalRTabId();

  if (existingTabId) {
    return existingTabId;
  }

  const newTabId = uuidv4();
  setSignalRTabId(newTabId);

  return newTabId;
};

export default getOrCreateSignalRTabId;
